import { CubeTimeDimensionGranularity } from "../../../enum/cube-schema.enum";
import { CubeConfigDto } from "../../common/request/cube-config.dto";

export interface QueryUserCountRequestParamsDto {
    startDate: string;
    endDate: string;
    teamId: string;
    appIds: string[];
    userIds?: string[];
    frequency: CubeTimeDimensionGranularity;
    includeSubscriptions?: boolean;
}